function zip<A, B>(a: A[], b: B[]): [[A, B]];

function zip<T>(...arrays: T[][]) {
  const minLength = Math.min(...arrays.map((a) => a.length));
  const indices = Array.from(Array(minLength).keys());
  return indices.map((i) => arrays.map((a) => a[i]));
}

export default zip;
